<template>
	<div class="page">
		<div class="cont">
			<Breadcrumb :pathList="pathList"></Breadcrumb>
			<div class="result">共找到 <span>{{cartList.length}}</span> 门课程</div>
			<div class="wbox" v-for="(item,index) in cartList" :key="index">
				<div class="flex botl">
					<div class="flex pointer">
						<img v-if="item.checked" @click="carItemClick(index,false)" src="../../assets/icon/xz.png"
							style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
						<img v-else @click="carItemClick(index,true)" src="../../assets/icon/wxz.png"
							style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
					</div>
					<!-- <el-checkbox cricle v-model="item.checked" style="margin-right: 20px;"
						@change="checkCourse"></el-checkbox> -->
					<div class="flex" style="position: relative;">
						<img :src="item.img" style="width: 138px;height: 78px;border-radius: 9px;" />
						<div class="over" v-if="item.vis==2">已失效</div>
						<div class="right flex-1">
							<div class="name">{{item.course_name}}</div>
							<!-- <div class="xy">加工中心学院</div> -->
						</div>
					</div>
				</div>
				<div class="flex flex-b botl" v-for="(itm,idx) in cartList[index].chapter">
					<div class="flex">
						<div class="flex pointer">
							<img v-if="!itm.checked" @click="itm.is_buy!=1?itmClick(index,idx,true):''" src="../../assets/icon/wxz.png"
								style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
							<img v-else @click="itm.is_buy!=1?itmClick(index,idx,false):''" src="../../assets/icon/xz.png"
								style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
						</div>
						<!-- <el-checkbox cricle v-model="itm.checked" style="margin-right: 20px;"
							@change="checkChapter"></el-checkbox> -->
						<div class="num">{{itm.name}}</div>
						<div class="numName">{{itm.desc}}</div>
					</div>
					<div class="yg" v-if="itm.is_buy==1">已购</div>
				</div>
				<div class="flex flex-b" :class="item.vis==1?'':'gray'" style="margin-top: 14px;">
					<div class="total">共{{cartList[index].chapter.length}}个章节</div>
					<div class="score">{{item.selectTotalScoreItem?item.selectTotalScoreItem:(item.score-loginUser.member.discount*cartList[index].chapter.length>0?item.score-loginUser.member.discount*cartList[index].chapter.length:0)}}<span>积分</span>
					</div>
				</div>
			</div>
		</div>
		<div class="bottomFixed flex flex-b">
			<div class="flex">
				<img src="../../assets/icon/wxz.png" class="pointer" @click="allSelectClick(true)" v-if="!allSelect"
					style="width: 18px;height: 18px;margin-right: 14px;" alt="" />
				<img src="../../assets/icon/xz.png" class="pointer" @click="allSelectClick(false)" v-else
					style="width: 18px;height: 18px;margin-right: 14px;" alt="" />
				<div class="all">{{!allSelect?'全选':'取消'}}</div>
				<div class="delete pointer" v-if="selectCarList.length>0" @click="delCarListClick">删除选择</div>
			</div>
			<div class="flex">
				<div>
					<div class="flex tot">合计：<div class="score" style="padding-bottom: 6px;">
							{{selectTotalScore}}<span>积分</span>
						</div>
					</div>
					<div class="t-r" style="font-size: 13px;color: #000000;">共选 {{selectCarList.length}} 个章节</div>
				</div>
				<div class="login-btn pointer" @click="buyClick"><span class="text">立即购买</span></div>
			</div>
		</div>
		<toTop></toTop>
		<Footer></Footer>
	</div>
</template>

<script>
	import Utils from "@/jslibs/utils";
	import {
		cart,
		delCart
	} from "@/api/cart";
	import {
		getMyCourse,
		getUser,
		EditUser,
	} from '@/api/mine';
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import toTop from '../../components/toTop.vue'
	import Footer from '../../components/Footer.vue'
	export default {
		data() {
			return {
				pathList: [{
					title: '我的',
					path: '/mine'
				}, {
					title: '购物车',
					path: ''
				}],
				showBackToTop: false,
				cartList: [],
				selectCarList: [],
				allSelect: false,
				selectTotalScore: 0,
				selectChapters: [],
				sessionCarChapters: [],
				selectTotalScoreOrig: 0,
				totalChapter: 0,
				loginUser: {
					member: {}
				},
			}
		},
		components: {
			Breadcrumb,
			Footer,
			toTop
		},
		mounted() {
			if (Utils.getCookie('loginUser')) {
				this.getUser()
			}
		},
		methods: {
			async getUser() {
				const {
					status,
					data
				} = await getUser({})
				this.loginUser = {
					...data.result
				}
				this.cart()
			},
			buyClick() {
				let arrs = []
				this.cartList.forEach(item => {
					let obj = {
						...item,
						chapter: []
					}
					item.chapter.forEach(_item => {
						if (_item.checked) {
							obj.chapter.push(_item)
						}
					})
					if (obj.chapter.length != 0) {
						arrs.push(obj)
					}
				})
				this.sessionCarChapters = arrs
				if (this.sessionCarChapters.length == 0) {
					this.$message({
						message: "请选择课程",
						type: "warning"
					});
					return
				}
				localStorage.setItem('sessionCarChapters', JSON.stringify(this.sessionCarChapters))
				this.toPage('/cartCourseBuy?selectTotalScore=' + this.selectTotalScore + '&selectTotalScoreOrig=' + this
					.selectTotalScoreOrig + '&chapterNum=' + this.selectChapters.length)
			},
			getScore(items) {
				let arrs = items.map(item => parseFloat(item.score))
				return arrs.reduce((a, b) => a + b)
			},
			getStaticData() {
				let that = this
				that.totalChapter = 0
				that.selectTotalScoreOrig = 0
				that.selectTotalScore = 0
				that.cartList.forEach(item => {
					let itemPrice = 0
					if (item.checked) {
						that.selectTotalScoreOrig += parseInt(item.score)
						that.selectTotalScore += (parseInt(item.score) - parseInt(that.loginUser
							.member ? that.loginUser.member.discount : 0) * item.chapter.length)
						itemPrice += (parseInt(item.score) - parseInt(that.loginUser
							.member ? that.loginUser.member.discount : 0) * item.chapter.length)
					} else {
						that.$set(item, 'selectTotalScoreItem', 0)
					}
					item.chapter.forEach(_item => {
						if (_item.checked) {
							that.totalChapter += 1
							if (!item.checked) {
								that.selectTotalScoreOrig += parseInt(_item.score)
								that.selectTotalScore += (parseInt(_item.score) - parseInt(that.loginUser
									.member ? that.loginUser.member.discount : 0))
								itemPrice += (parseInt(_item.score) - parseInt(that.loginUser
									.member ? that.loginUser.member.discount : 0))
								that.$set(item, 'selectTotalScoreItem', itemPrice)
							} else {
								that.$set(item, 'selectTotalScoreItem', (parseInt(item.score) - parseInt(that.loginUser
							.member ? that.loginUser.member.discount : 0) * item.chapter.length))
							}
						}
					})
				})
			},
			allSelectClick(flag) {
				this.allSelect = flag
				let that = this
				if (flag) {
					this.cartList.forEach(item => {
						item.checked = true
						item.chapter.forEach(_item => {
							_item.checked = true
						})
					})
					let arrs = []
					this.cartList.forEach(item => {
						item.chapter.forEach(_item => {
							if (_item.checked) {
								let fidIndex = that.selectCarList.findIndex(fid => {
									return fid == _item.uuid
								})
								if (fidIndex == -1) {
									that.selectCarList.push(_item.uuid)
									arrs.push(parseFloat(_item.score))
									that.selectChapters.push(parseFloat(_item.score))
								}
							}
						})
					})
				} else {
					this.cartList.forEach(item => {
						item.checked = false
						item.chapter.forEach(_item => {
							_item.checked = false
						})
					})
					this.selectCarList = []
					this.selectTotalScore = 0
					this.selectTotalScoreOrig = 0
					this.selectChapters = []
				}
				this.getStaticData()
			},
			async delCarListClick() {
				const {
					status,
					data
				} = await delCart({
					ids: this.selectCarList.toString()
				})
				if (data.result) {
					this.$message({
						message: "删除成功",
						type: "success"
					});
					this.cart()
					this.selectCarList = []
					this.allSelect = false
				}
			},
			itmClick(index, idx, flag) {
				let that = this
				that.selectCarList = []
				that.selectChapters = []
				this.cartList[index].chapter[idx].checked = flag
				let findIndex = this.cartList[index].chapter.findIndex(itm => {
					return itm.checked == false
				})
				if (findIndex == -1) {
					this.cartList[index].checked = true
				} else {
					this.cartList[index].checked = false
				}
				let arrs = []
				this.cartList.forEach(item => {
					item.chapter.forEach(_item => {
						if (_item.checked) {
							let fidIndex = that.selectCarList.findIndex(fid => {
								return fid == _item.uuid
							})
							if (fidIndex == -1) {
								that.selectCarList.push(_item.uuid)
								that.selectChapters.push(parseFloat(_item.score))
								arrs.push(parseFloat(_item.score))
							}
						}
					})
				})
				this.getStaticData()
			},
			carItemClick(index, flag) {
				let that = this
				this.cartList[index].checked = flag
				that.selectCarList = []
				that.selectChapters = []
				if (flag) {
					this.cartList[index].chapter.forEach(item => {
						item.checked = true
					})
				} else {
					this.cartList[index].chapter.forEach(item => {
						item.checked = false
					})
				}
				let arrs = []
				this.cartList.forEach(item => {
					item.chapter.forEach(_item => {
						if (_item.checked) {
							let fidIndex = that.selectCarList.findIndex(fid => {
								return fid == _item.uuid
							})
							if (fidIndex == -1) {
								that.selectCarList.push(_item.uuid)
								that.selectChapters.push(parseFloat(_item.score))
								arrs.push(parseFloat(_item.score))
							}
						}
					})
				})
				this.getStaticData()
			},
			async cart() {
				const {
					status,
					data
				} = await cart({
					chapter_uuid: ''
				})
				this.cartList = data.result
				this.cartList.forEach(item => {
					this.$set(item, 'checked', false)
					item.chapter.forEach(_item => {
						this.$set(_item, 'checked', false)
					})
				})
			},
			toPage(path) {
				this.$router.push({
					path: path
				})
			},
		},
	}
</script>

<style lang="less" scoped>
	.cont {
		padding: 30px 133px 0;
		min-height: 100vh;

		.result {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			color: #000000;
			line-height: 60px;

			span {
				color: #00A73C;
			}
		}

		.wbox {
			background: #fff;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 0 20px 20px;
			margin: 0 223px 20px;

			.over {
				position: absolute;
				left: 0;
				top: 0;
				width: 138px;
				height: 78px;
				background: rgba(0, 0, 0, 0.56);
				border-radius: 9px 9px 9px 9px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #FFFFFF;
			}

			.right {
				margin-left: 20px;

				.name {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 18px;
					color: #000000;
				}

				.xy {
					margin-top: 10px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #999999;
				}
			}

			.botl {
				padding: 16px 0;
				border-bottom: 1px solid #EEEEEE;

				&:last-child {
					border-bottom: none;
				}

				.num {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #999999;
				}

				.numName {
					margin-left: 16px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #333333;
				}
			}

			.yg {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: rgba(0, 167, 60, 0.56);
			}

			.total {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #D7B155;
			}
		}

		.gray {
			filter: grayscale(100%);
			opacity: 0.5;
		}
	}

	.score {
		font-family: DINPro, DINPro;
		font-weight: bold;
		font-size: 22px;
		color: #00A73C;

		span {
			margin-left: 6px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #00A73C;
		}
	}

	.bottomFixed {
		margin-top: 100px;
		width: 100%;
		background: #FFFFFF;
		box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
		padding: 20px 356px;

		.all {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
		}

		.delete {
			margin-left: 10px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #FC5F5F;
		}

		.tot {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #000000;
		}

		.login-btn {
			margin-left: 30px;
			width: 276px;
			height: 50px;
			background: url('../../assets/images/login/loginbtn.png') no-repeat;
			background-size: 100% 100%;
			margin-top: 13px;
			display: flex;
			align-items: center;
			justify-content: center;

			.text {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 16px;
				text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
				text-align: center;
				font-style: normal;
				text-transform: none;
				background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			}
		}
	}

	::v-deep .h90 {
		height: 0 !important;
	}
</style>